import React, { useState } from 'react';
import {Link, NavLink} from 'react-router-dom';
import './Header.css';
import config from "../../config";

function Header() {
    const {team} = config;
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const goToBoutique = () => {
        window.open("https://clubshop.macron.com/nantes/3672337ulon-futsal/kit-top-up?p=2", "_blank");
    };

    const menuItems = [
        { name: "Accueil", path: "/" },
        { name: "Club", path: "/club" },
        { name: "Équipe Première", path: "/equipe-premiere" },
        { name: "Sections", path: "/sections" },
        { name: "Médias", path: "/medias" },
        //{ name: "Actualités", path: "/actualites" },
        { name: "Contact", path: "/contact" },
    ];

    return (
        <header className="header">
            <div className="logo-container">
                <Link to="/">
                    <img src={team.logoUrl} alt="Logo du club" className="logo" />
                </Link>
            </div>
            <button
                className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
                ☰
            </button>
            <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
                <ul>
                    {menuItems.map((item) => (
                        <li key={item.name}>
                            <NavLink
                                to={item.path}
                                className={({ isActive }) =>
                                    isActive ? 'active' : ''
                                }
                                onClick={() => setIsMenuOpen(false)} // Fermer le menu après un clic
                            >
                                {item.name}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
            <button className="cta-button" onClick={goToBoutique}>Boutique</button>
        </header>
    );
}

export default Header;
